// src/components/chat/ChatBoot.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBillings } from "../../contexts/BillingContext";
import { useAuth } from "../../contexts/AuthContext";
import { useChat } from "../../contexts/ChatContext";

/**
 * ChatBoot
 * - Enterprise SaaS behavior:
 *   - Autoload bubble ONLY for trialing users (quiet bubble)
 *   - Do nothing for paid/expired users (performance-first)
 * - Optional:
 *   - Skip autoload inside /form-builder
 *   - Attach user context to chat once loaded
 */
export default function ChatBoot() {
  const location = useLocation();
  const { currentUser, organizationId, userProfile } = useAuth();
  const { currentSubscription, billingLoaded, reconciling } = useBillings();
  const { showBubble, identifyChat, hideChat } = useChat();

  const status = currentSubscription?.status ?? null;
  const isTrialing = status === "trialing";

useEffect(() => {
//  console.log("[ChatBoot]", {
//    billingLoaded,
//    reconciling,
//    status: currentSubscription?.status ?? null,
//    isTrialing,
//    path: location.pathname,
//    uid: currentUser?.uid ?? null,
//    domain: typeof window !== "undefined" ? window.location.host : null,
//  });

  // Wait for billing truth; avoid flicker during reconciliation
  if (!billingLoaded || reconciling) return;

  // Optional: keep chat off inside form builder (remove if you want it there too)
  if (location.pathname.includes("/form-builder/")) {
    hideChat();
    return;
  }

  if (!isTrialing) {
    // Ensure it's not visible if a user transitions from trial->paid in-session
    hideChat();
    return;
  }

  // Trialing: show bubble quietly (no maximize)
  (async () => {
    const ok = await showBubble();
    if (!ok) return;

    identifyChat({
      email: currentUser?.email || undefined,
      name:
        userProfile?.firstName || userProfile?.lastName
          ? `${userProfile?.firstName || ""} ${userProfile?.lastName || ""}`.trim()
          : undefined,
      organizationId: organizationId || undefined,
      billingStatus: status || undefined,
    });
  })();
  }, [
    billingLoaded,
    reconciling,
    isTrialing,
    location.pathname,
    showBubble,
    identifyChat,
    hideChat,
    currentUser?.email,
    organizationId,
    userProfile?.firstName,
    userProfile?.lastName,
    status,
  ]);

  return null;
}
